import { render, staticRenderFns } from "./gaming.vue?vue&type=template&id=fb5152d2&scoped=true"
import script from "./gaming.vue?vue&type=script&lang=js"
export * from "./gaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5152d2",
  null
  
)

export default component.exports